<script lang="ts">
    import cornerTopLeft from 'src/components/main/#assets/top-left-border.svg'
    import cornerTopRight from 'src/components/main/#assets/top-right-border.svg'
    import cornerBottomLeft from 'src/components/main/#assets/bottom-left-border.svg'
    import cornerBottomRight from 'src/components/main/#assets/bottom-right-border.svg'
    import battles from './battles.svg'
    import bonuses from './bonuses.svg'
    import weeklyLeagues from './weekly-leagues.svg'
    import rankes from './rankes.svg'
</script>

<section class="utility" id="in-game-utility">
    <div class="container">
        <div class="title">
            In-Game Utility
            <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
            <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
            <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
            <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
        </div>
        <div class="row">
            <div class="item-card col-md-6 col-lg-3">
                <div class="card-icon d-lg-none"><img src="{battles}" alt=""></div>
                <div>
                    <div class="card-title">Battles</div>
                    <div class="card-description">Use in game battles and upgrade your Meowgons</div>
                    <div class="card-icon d-none d-lg-block"><img src="{battles}" alt=""></div>
                </div>
            </div>
            <div class="item-card col-md-6 col-lg-3">
                <div class="card-icon d-lg-none"><img src="{bonuses}" alt=""></div>
                <div>
                    <div class="card-title">Bonuses</div>
                    <div class="card-description">Gain exp faster, get more energy and boost your battle stats</div>
                    <div class="card-icon d-none d-lg-block"><img src="{bonuses}" alt=""></div>
                </div>
            </div>
            <div class="item-card col-md-6 col-lg-3">
                <div class="card-icon d-lg-none"><img src="{weeklyLeagues}" alt=""></div>
                <div>
                    <div class="card-title">Weekly leagues</div>
                    <div class="card-description">Compete against equal opponents and win tournaments</div>
                    <div class="card-icon d-none d-lg-block"><img src="{weeklyLeagues}" alt=""></div>
                </div>
            </div>
            <div class="item-card col-md-6 col-lg-3">
                <div class="card-icon d-lg-none"><img src="{rankes}" alt=""></div>
                <div>
                    <div class="card-title">Rankes</div>
                    <div class="card-description">Participate in tournaments to take your place on the leaderboard</div>
                    <div class="card-icon d-none d-lg-block"><img src="{rankes}" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .utility {
        position: relative;
        padding: 200px 0 0;
        background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.72), #040404);
    }

    .title {
        font-size: 100px;
        font-weight: 700;
        padding: 18px 18px 0;
        background: linear-gradient(84deg, #FFF0E2 47%, #FFB287 71%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: normal;
        text-transform: uppercase;
        display: table;
        margin: 0 auto 100px;
        position: relative;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .card-title {
        color: white;
        text-align: center;
        font-size: 40px;
        font-weight: 700;
        line-height: 100%;
        margin-bottom: 20px;
    }

    .card-description {
        color: #B0A59D;
        text-align: center;
        font-size: 21px;
        font-weight: 400;
        line-height: 120%;
        margin-bottom: 40px;
    }

    .card-icon {
        text-align: center;
    }

    @media(max-width: 1750px) {
        .utility {
            padding: 100px 0 0;
        }

        .card-title {
            font-size: 36px;
        }

        .card-description {
            font-size: 19px;
            min-height: 70px;
        }
    }

    @media(max-width: 1400px) {
        .title {
            font-size: 70px;
            margin: 0 auto 80px;
        }

        .card-title {
            font-size: 30px;
        }
    }

    @media(max-width: 1200px) {
        .card-title {
            font-size: 24px;
        }

        .card-description {
            font-size: 17px;
            min-height: 82px;
            margin-bottom: 30px;
        }

        .card-icon img {
            width: 120px;
        }

        .title {
            font-size: 60px;
        }
    }

    @media(max-width: 991px) {
        .utility {
            padding: 50px 0 0;
        }

        .title {
            font-size: 40px;
            width: 100%;
            text-align: center;
            padding: 5px 10px 0;
            margin-bottom: 50px;
        }

        .item-card {
            display: flex;
            margin-bottom: 30px;
        }

        .card-title {
            font-size: 24px;
            text-align: left;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .card-description {
            font-size: 16px;
            text-align: left;
            min-height: initial;
            margin-bottom: 0;
        }

        .card-icon img {
            width: 100px;
            min-width: 100px;
        }

        .card-icon {
            margin-right: 20px;
        }
    }
</style>
